import { inject, observer } from 'mobx-react';
import React from 'react';
import { Container } from 'reactstrap';

import ThankYouPageContent from '../../components/checkout/confirmation/ThankYouPageContent';
import RobotsMeta from '../../components/head/RobotsMeta';
import SEOTitle from '../../components/head/SEOTitle';
import GenericLayout from '../../components/layout/GenericLayout';
import Page from '../../components/layout/Page';
import globalTranslations from '../../i18n/globalTranslations';
import { modelOf } from '../../prop-types';
import ConfigStore from '../../store/ConfigStore';
import TrackingStore from '../../store/TrackingStore';
import CommonPage from '../../types/CommonPage';
import OrderType from '../../types/order/OrderType';
import TrackingEventType from '../../types/TrackingPageType';

const ThankYouPage = ({ configStore, trackingStore }) => {
  const sendTrackingData = (currentOrder) => {
    if (
      !configStore.integrations.spotmore.enabled ||
      typeof document === 'undefined' ||
      !currentOrder ||
      currentOrder.is_success_seen
    ) {
      return null;
    }

    if (configStore.integrations.spotmore.enabled && window.crmtracker) {
      window.crmtracker.sendData();
    }

    trackingStore.setPageView({
      page: TrackingEventType.CHECKOUT_SUCCESS,
      refererUrl: document.referrer,
      visitedUrl: window.location.href,
    });
    trackingStore.postPageView();
  };

  const onOrderSuccess = (currentOrder) => {
    !window.isSSR && sendTrackingData(currentOrder);
  };

    return (
      <Page
        name={CommonPage.CHECKOUT_SUCCESS}
        className="ThankYouPage"
        onDefinedTrackingPage={TrackingEventType.CHECKOUT_SUCCESS}
      >
        <Container className="ThankYouPage__container">
          <GenericLayout
            content={
              <>
                <SEOTitle
                  title={{ ...globalTranslations.successfulPurchasePageTitle }}
                />
                <RobotsMeta noindex />
                <ThankYouPageContent
                  onOrderSuccess={onOrderSuccess}
                  orderType={OrderType.PURCHASE}
                />
              </>
            }
          />
        </Container>
      </Page>
    );
}

ThankYouPage.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  trackingStore: modelOf(TrackingStore).isRequired,
};

export default inject('configStore', 'trackingStore')(observer(ThankYouPage));
